// Soft colors for group markers and UI elements
export const SOFT_COLORS = [
  '#2d3b60',
  '#586c31',
  '#c77b77',
  '#5d7599',
  '#5f2f2a',
  '#6e356b',
  '#005c4c',
  '#8b2d18',
  '#24756c',
  '#b28a2c',
  '#30356e',
  '#611823',
  '#8f7963',
  '#751b2d',
  '#556780',
];

const groupColorMap = new Map();
let nextColorIndex = 0;

export const getColorForGroup = (groupName) => {
  if (!groupName) return '#4285f4';
  if (groupColorMap.has(groupName)) return groupColorMap.get(groupName);
  const color = SOFT_COLORS[nextColorIndex % SOFT_COLORS.length];
  groupColorMap.set(groupName, color);
  nextColorIndex++;
  return color;
};
